import React from "react";
import { generateButtonDesignStyles, IWebsiteBuilderButton } from "../../../../../nodes/element/websiteBuilderButton";
import classNames from "classnames";
import { useAppSelector } from "hooks/redux";

interface IWebsiteBuilderButtonViewProps {
  node: IWebsiteBuilderButton;
}

export function WebsiteBuilderButtonView(props: IWebsiteBuilderButtonViewProps) {
  const { node } = props;

  const selectedNodeId = useAppSelector(store => store.websiteBuilderStore.selectedNode?.id);
  const selected = selectedNodeId === node.id;

  const settings = node.element.settings;
  const designStyles = generateButtonDesignStyles(settings);

  return (
    <button
      className={classNames(designStyles.className, "element-content", {
        "element-content-selected": selected,
      })}
      style={designStyles.style}
    >
      {settings.label}
    </button>
  );
}
